module.exports = __webpack_public_path__ + "static/newtothecrewvest-4624611ad25d7c0f27817a3449690070.jpeg";